export const getCookie = (name: string): string | null => {
    for (const cookie of document.cookie.split(';')) {
        const trimmedCookie = cookie.trim();
        const firstEquals = trimmedCookie.indexOf('=');

        if (firstEquals === -1) {
            console.warn(`getCookie: Broken cookie part => ${cookie}`);
            continue;
        }

        const cookieName = trimmedCookie.substring(0, firstEquals);
        const cookieValue = trimmedCookie.substring(firstEquals + 1);

        if (cookieName === name) {
            return cookieValue;
        }
    }

    return null;
};

const setCookieInner = (name: string, value: string, days: number, domain: string): void => {
    const date = new Date();
    let expires = '';

    if (days !== 0) {
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
    }

    document.cookie = `${name}=${value}${expires}; path=/; domain=${domain}`;
};

export const setCookie = (name: string, value: string, days: number): void => {
    setCookieInner(name, value, days, location.hostname);
    setCookieInner(name, value, days, `.${location.hostname}`);
};
